import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const Administration = () => {
  return (
    <Layout>
      <h1>Administration</h1>
    </Layout>
  );
};

export default Administration;

const styles = StyleSheet.create({});
